var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandQueued(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 149,
    viewBox: "0 0 74 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3608 28.3066L3.28857 75.7887C5.63906 80.897 9.1864 85.3634 13.63 88.8094L60.0264 37.0257C56.2194 33.0862 51.5377 30.0992 46.3608 28.3066Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1879 28.3312V0.566406H23.5205V28.2453C30.8767 25.759 38.8508 25.7892 46.1879 28.3312Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5205 93.7802V122.19H46.1879V93.6943C38.8508 96.2363 30.8767 96.2665 23.5205 93.7802Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9761 95.9893C15.6902 95.9893 0 80.2991 0 61.0132C0 41.7273 15.6902 26.0371 34.9761 26.0371C54.2619 26.0371 69.9521 41.7273 69.9521 61.0132C69.9521 80.2991 54.2619 95.9893 34.9761 95.9893ZM34.9761 26.2808C15.8246 26.2808 0.243736 41.8617 0.243736 61.0132C0.243736 80.1646 15.8246 95.7456 34.9761 95.7456C54.1275 95.7456 69.7084 80.1646 69.7084 61.0132C69.7084 41.8617 54.1275 26.2808 34.9761 26.2808Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3589 61.0128C10.3589 67.5417 12.9525 73.8032 17.5691 78.4199C22.1858 83.0365 28.4473 85.6301 34.9762 85.6301V36.3955C28.4473 36.3955 22.1858 38.9891 17.5691 43.6057C12.9525 48.2224 10.3589 54.4839 10.3589 61.0128Z",
    fill: "#575A89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9758 36.3955V85.6301C41.5047 85.6301 47.7662 83.0365 52.3829 78.4199C56.9995 73.8032 59.5931 67.5417 59.5931 61.0128C59.5931 54.4839 56.9995 48.2224 52.3829 43.6057C47.7662 38.9891 41.5047 36.3955 34.9758 36.3955Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.976 65.6439C36.8606 65.6439 38.3883 64.1162 38.3883 62.2316C38.3883 60.3471 36.8606 58.8193 34.976 58.8193C33.0915 58.8193 31.5637 60.3471 31.5637 62.2316C31.5637 64.1162 33.0915 65.6439 34.976 65.6439Z",
    fill: "#2F2E41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9701 49.7178L35.8202 56.4622L36.6704 63.2066H34.9701H33.2698L34.1199 56.4622L34.9701 49.7178Z",
    fill: "#2F2E41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3218 62.423L44.2289 62.8378L33.1362 63.2524L33.1423 62.2835L33.1484 61.3145L44.235 61.8687L55.3218 62.423Z",
    fill: "#2F2E41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1709 63.9378C70.6065 63.9378 70.3787 63.5501 70.0902 63.0593C70.0181 62.9367 69.94 62.8038 69.8496 62.6632L70.0548 62.5314C70.1471 62.6749 70.2269 62.8106 70.3004 62.9358C70.5877 63.4248 70.746 63.6941 71.1709 63.6941C72.5821 63.6941 73.7301 61.3433 73.7301 58.4538C73.7301 55.5643 72.5821 53.2135 71.1709 53.2135C70.3561 53.2135 69.7896 53.7162 69.334 54.8434L69.1079 54.752C69.6061 53.5194 70.2423 52.9697 71.1709 52.9697C72.7163 52.9697 73.9738 55.4298 73.9738 58.4538C73.9738 61.4777 72.7163 63.9378 71.1709 63.9378Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3883 148.026C56.6954 148.026 71.5363 147.481 71.5363 146.808C71.5363 146.134 56.6954 145.589 38.3883 145.589C20.0811 145.589 5.24023 146.134 5.24023 146.808C5.24023 147.481 20.0811 148.026 38.3883 148.026Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 123.999C40 121.347 41.0536 118.803 42.9289 116.928C44.8043 115.053 47.3478 113.999 50 113.999C52.6522 113.999 55.1957 115.053 57.0711 116.928C58.9464 118.803 60 121.347 60 123.999C60 126.651 58.9464 129.195 57.0711 131.07C55.1957 132.945 52.6522 133.999 50 133.999C47.3478 133.999 44.8043 132.945 42.9289 131.07C41.0536 129.195 40 126.651 40 123.999V123.999ZM49.4293 128.279L55.1867 121.082L54.1467 120.25L49.2373 126.384L45.76 123.487L44.9067 124.511L49.4293 128.28V128.279Z",
    fill: "#5EFF77"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.5205,
    y1: 14.6083,
    x2: 46.1879,
    y2: 14.6083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.5205,
    y1: 108.106,
    x2: 46.1879,
    y2: 108.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.9758,
    y1: 61.2956,
    x2: 59.5931,
    y2: 61.2956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5436"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandQueued);
export default __webpack_public_path__ + "static/media/commandQueued.711eb02fa8f0ff5092ae80f43e93268a.svg";
export { ForwardRef as ReactComponent };